"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    deepAssign: function() {
        return deepAssign;
    },
    filterObject: function() {
        return filterObject;
    },
    getObjectDiff: function() {
        return getObjectDiff;
    },
    getRecursive: function() {
        return getRecursive;
    },
    mapObject: function() {
        return mapObject;
    },
    setRecursive: function() {
        return setRecursive;
    },
    traverseObject: function() {
        return traverseObject;
    }
});
const _extends = require("@swc/helpers/_/_extends");
const _compare = require("./compare");
const _validation = require("./validation");
function traverseObject(obj, callback, path, cache, parent) {
    const circularCache = cache || new Set();
    Object.entries(obj).forEach(([key, value])=>{
        const newPath = path === undefined ? [
            key
        ] : [
            ...path,
            key
        ];
        const isLeaf = !(0, _validation.isPlainObject)(value);
        const isCircularRef = !isLeaf && circularCache.has(value);
        let stopTraversing = false;
        const nodeVisited = {
            key,
            isLeaf,
            isCircularRef,
            value,
            parent,
            path: newPath,
            // TODO: This doesn't make much sense here since using it would
            // cause this to fail.
            setValue: (newValue)=>{
                obj[key] = newValue;
            },
            stopTraversingNode: ()=>{
                stopTraversing = true;
            }
        };
        callback(nodeVisited);
        if (!isLeaf && !isCircularRef && !stopTraversing) {
            circularCache.add(obj);
            traverseObject(value, callback, newPath, cache, nodeVisited);
        }
    });
}
function setRecursive(obj, nodePath, value, overwriteBranch = false) {
    (0, _validation.assertIsTrue)(nodePath.length > 0, 'You must provide nodePath with at least one element');
    const parents = nodePath.slice(0, nodePath.length - 1);
    let currentNode = obj;
    parents.forEach((parent)=>{
        // eslint-disable-next-line no-prototype-builtins
        if (currentNode.hasOwnProperty(parent)) {
            if (!(0, _validation.isPlainObject)(currentNode[parent])) {
                throw new Error(`The path "${nodePath.join('.')}" is incompatible with existing nodes in the object.`);
            }
            currentNode = currentNode[parent];
            return;
        }
        currentNode[parent] = {};
        currentNode = currentNode[parent];
    });
    const lastNode = nodePath[nodePath.length - 1];
    if (!overwriteBranch) {
        if (// eslint-disable-next-line no-prototype-builtins
        currentNode.hasOwnProperty(lastNode) && (0, _validation.isPlainObject)(currentNode[lastNode])) {
            throw new Error(`The path "${nodePath.join('.')}" already exists with children.`);
        }
    }
    currentNode[lastNode] = value;
}
function getRecursive(obj, nodePath) {
    (0, _validation.assertIsTrue)(nodePath.length > 0, 'You must provide nodePath with at least one element');
    const parents = nodePath.slice(0, nodePath.length - 1);
    let currentNode = obj;
    parents.forEach((parent)=>{
        if (currentNode) {
            if (// eslint-disable-next-line no-prototype-builtins
            currentNode.hasOwnProperty(parent) && (0, _validation.isPlainObject)(currentNode[parent])) {
                currentNode = currentNode[parent];
                return;
            }
            currentNode[parent] = {};
            currentNode = currentNode[parent];
        }
    });
    const lastNode = nodePath[nodePath.length - 1];
    return currentNode ? currentNode[lastNode] : undefined;
}
function getObjectDiff(obj1, obj2, options = {}) {
    const out = {};
    var _options_comparer;
    const comparer = (_options_comparer = options.comparer) != null ? _options_comparer : (0, _compare.getAnyComparer)();
    // delete things in obj1 but not obj2
    traverseObject(obj1, (node)=>{
        const currentValue = getRecursive(obj2, node.path);
        if (node.value !== undefined && currentValue === undefined) {
            setRecursive(out, node.path, undefined);
            // don't continue traversing
            if (!node.isLeaf) {
                node.stopTraversingNode();
            }
        }
    });
    // add things in obj2 and not in obj1
    traverseObject(obj2, (node)=>{
        if (!node.isLeaf) {
            return;
        }
        const oldValue = getRecursive(obj1, node.path);
        if (!Array.isArray(node.value) && comparer(node.value, oldValue) !== 0) {
            setRecursive(out, node.path, node.value);
        }
    });
    return out;
}
function filterObject(obj1, obj2) {
    const out = {};
    traverseObject(obj2, (node)=>{
        const value = getRecursive(obj1, node.path);
        if (node.isLeaf) {
            setRecursive(out, node.path, value);
        }
    });
    return out;
}
function mapObject(obj, callback) {
    const out = {};
    traverseObject(obj, (node)=>{
        if (node.isLeaf) {
            callback(_extends._({}, node, {
                setValue: (newValue)=>{
                    setRecursive(out, node.path, newValue);
                }
            }));
        }
    });
    return out;
}
function deepAssign(obj1, obj2) {
    traverseObject(obj2, (node)=>{
        if (node.isLeaf) {
            setRecursive(obj1, node.path, node.value);
        }
    });
    return obj1;
}

//# sourceMappingURL=object-traverser.js.map